module.exports = __webpack_public_path__ + "static/head-d64e98ce1a329a154b45a7f8f54fe9b6.png";